import { Control, Controller } from "react-hook-form";
import { FormControl, InputLabel } from "@mui/material";

import { Loading } from "../..";
import React from "react";
import { SelectCustom } from "../../../styles/styledComponents";

interface ISelectControllerProps {
  id?: string;
  name: string;
  label?: string;
  control: Control<any>;
  options: { value: string | any, label: string }[];
  fullWidth?: boolean;
  onChanged?: (e: any) => void;
  defaultValue?: string | number;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

const SelectController = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  options = [],
  onChanged,
  defaultValue,
  placeholder,
  isLoading = false,
  disabled = false,
}: ISelectControllerProps) => {
  const fieldId = id || name;

  return (
    <>
      { label &&
        <InputLabel sx={{ marginBottom: "6px" }} htmlFor={fieldId}>{label}</InputLabel>
      }
      <FormControl fullWidth={fullWidth}>
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            <>
              <SelectCustom
                id={fieldId}
                error={!!fieldState.error}
                onChange={(e) => {
                  field.onChange(e);
                  onChanged && onChanged(e.target.value);
                }}
                value={field.value}
                defaultValue={defaultValue}
                disabled={isLoading || disabled}
              >
                <option aria-label="None" hidden>{isLoading ? "Loading..." : placeholder}</option>
                <option aria-label="None" disabled>{placeholder}</option>
                { options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                )) }
              </SelectCustom>
              { isLoading &&
                <Loading size={20} sx={{ position: "absolute", right: 24, top: 8 }} />
              }
            </>
          }
        />
      </FormControl>
    </>
  );
};

export default React.memo(SelectController);
